// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes animate-skeleton{0%{transform:translateX(-100%) translateY(-50%)}to{transform:translateX(100%) translateY(-50%)}}.administration-menu{display:flex;width:350px}.administration-menu__list-box{flex-basis:50%}.administration-menu__divider{width:90%;margin:15px 0 25px 0}", ""]);
// Exports
module.exports = exports;
